import React from 'react';
import * as s from './toggleButton.module.css';

interface ToggleButtonProps {
    content: string,
    toggled: boolean,
    onClick: any,
};

const ToggleButton: React.FC<ToggleButtonProps> = ({
    content,
    toggled,
    onClick,
}) => {
    return (
        <button
            className={`${ s.button } ${ toggled && s.toggled }`}
            onClick={() => onClick && onClick()}
        >
            { content }
        </button>
    );
};

export { ToggleButton };